import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Text Other Variables',
  basePath: '/text-other-vars',
  columns: [
    { key: 'var', label: 'Variable', sortable: true },
  ],
  fields: [
    { key: 'var', label: 'Variable', type: 'text', required: true },
  ],
  defaultSort: { field: 'var', dir: 'asc' },
});
